// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-file-upload .v-input__control {
  flex-direction: column;
}

:where(.vuetify-styles) .v-file-upload-dropzone {
  padding: 64px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
:where(.vuetify-styles) .v-file-upload-dropzone.v-sheet {
  display: flex;
  border-radius: 4px;
  border-style: dashed;
  border-width: 2px;
}
:where(.vuetify-styles) .v-file-upload-dropzone.v-file-upload-dropzone--density-compact {
  padding: 32px 0;
  flex-direction: row;
  gap: 1rem;
}
:where(.vuetify-styles) .v-file-upload-dropzone .v-overlay__scrim {
  pointer-events: none;
}
:where(.vuetify-styles) .v-file-upload-dropzone--disabled {
  pointer-events: none;
  opacity: var(--v-disabled-opacity);
}
:where(.vuetify-styles) .v-file-upload-dropzone--dragging > * {
  pointer-events: none;
}
:where(.vuetify-styles) .v-file-upload-dropzone--clickable {
  cursor: pointer;
}
:where(.vuetify-styles) .v-file-upload-dropzone--has-files:not(.v-file-upload-dropzone--clickable) {
  cursor: default;
}
:where(.vuetify-styles) .v-file-upload-dropzone--error.v-sheet {
  border-color: rgb(var(--v-theme-error));
}
:where(.vuetify-styles) .v-file-upload-dropzone--inset {
  padding: 16px;
}
:where(.vuetify-styles) .v-file-upload-dropzone input[type=file] {
  left: 0;
  opacity: 0;
  position: absolute;
  cursor: pointer;
  top: 0;
  z-index: -1;
}

:where(.vuetify-styles) .v-file-upload-title {
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
}

:where(.vuetify-styles) .v-file-upload-icon {
  opacity: var(--v-medium-emphasis-opacity);
  font-size: 3rem;
  margin-bottom: 1rem;
}
:where(.vuetify-styles) .v-file-upload-dropzone--density-comfortable .v-file-upload-icon {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}
:where(.vuetify-styles) .v-file-upload-dropzone--density-compact .v-file-upload-icon {
  font-size: 2rem;
  margin-bottom: 0rem;
}

:where(.vuetify-styles) .v-file-upload-divider {
  align-items: center;
  display: flex;
  margin: 32px 0;
  justify-content: center;
  width: 100%;
}
:where(.vuetify-styles) .v-file-upload-divider .v-divider__wrapper {
  max-width: 100%;
}

:where(.vuetify-styles) .v-file-upload-inset {
  width: 100%;
}

:where(.vuetify-styles) .v-file-upload-inset__action {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 8px 0;
}

:where(.vuetify-styles) .v-file-upload-list {
  margin: 16px 0;
}

:where(.vuetify-styles) .v-file-upload-item:not(:first-child) {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/labs/VFileUpload/VFileUpload.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".v-file-upload .v-input__control {\n  flex-direction: column;\n}\n\n.v-file-upload-dropzone {\n  padding: 64px 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.v-file-upload-dropzone.v-sheet {\n  display: flex;\n  border-radius: 4px;\n  border-style: dashed;\n  border-width: 2px;\n}\n.v-file-upload-dropzone.v-file-upload-dropzone--density-compact {\n  padding: 32px 0;\n  flex-direction: row;\n  gap: 1rem;\n}\n.v-file-upload-dropzone .v-overlay__scrim {\n  pointer-events: none;\n}\n.v-file-upload-dropzone--disabled {\n  pointer-events: none;\n  opacity: var(--v-disabled-opacity);\n}\n.v-file-upload-dropzone--dragging > * {\n  pointer-events: none;\n}\n.v-file-upload-dropzone--clickable {\n  cursor: pointer;\n}\n.v-file-upload-dropzone--has-files:not(.v-file-upload-dropzone--clickable) {\n  cursor: default;\n}\n.v-file-upload-dropzone--error.v-sheet {\n  border-color: rgb(var(--v-theme-error));\n}\n.v-file-upload-dropzone--inset {\n  padding: 16px;\n}\n.v-file-upload-dropzone input[type=file] {\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  z-index: -1;\n}\n\n.v-file-upload-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.v-file-upload-icon {\n  opacity: var(--v-medium-emphasis-opacity);\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n.v-file-upload-dropzone--density-comfortable .v-file-upload-icon {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n}\n.v-file-upload-dropzone--density-compact .v-file-upload-icon {\n  font-size: 2rem;\n  margin-bottom: 0rem;\n}\n\n.v-file-upload-divider {\n  align-items: center;\n  display: flex;\n  margin: 32px 0;\n  justify-content: center;\n  width: 100%;\n}\n.v-file-upload-divider .v-divider__wrapper {\n  max-width: 100%;\n}\n\n.v-file-upload-inset {\n  width: 100%;\n}\n\n.v-file-upload-inset__action {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 8px 0;\n}\n\n.v-file-upload-list {\n  margin: 16px 0;\n}\n\n.v-file-upload-item:not(:first-child) {\n  margin-top: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
